<div class="table-container px-2 pt-2">
  <div class="d-table table-input-grid">
    <div class="d-table-row">
      <div class="d-table-cell"></div>
      <div class="d-table-cell ig-title" *ngFor="let column of columns; trackBy:trackById; let columnIndex = index">
        <div *ngIf="column.lbl" class="text-center paragraph py-4 w-100 column-heading">
          {{column.lbl}}
        </div>
        <div class="d-table-row w-100 align-items-center d-flex justify-content-center">
          <div class="d-table-cell ig-input-field px-2 py-2 column-sub-heading"
            *ngFor="let subColumn of column.sclmns; trackBy:trackById; let subIndex = index">
            <div *ngIf="subColumn.lbl" class="text-center paragraph py-2">{{subColumn.lbl}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-table-row" *ngFor="let row of rows; trackBy:trackByIndex; let rowIndex = index">
      <div class="d-table-cell d-flex ig-table-row"><span
          class="secondary-paragraph text-left text-wrap">{{row?.ov}}</span>
      </div>
      <div class="d-table-cell col-5 row-element px-1"
        *ngFor="let column of columns; trackBy:trackById; let columnIndex = index">
        <div class="d-table-row d-flex align-items-center justify-content-around">
          <div class="d-table-cell ig-input-field px-2"
            *ngFor="let subColumn of column.sclmns; trackBy:trackById; let subIndex = index">
            <div class="form-input my-2">
              <input *ngIf="subColumn.typ === 'INPUT'" [value]="getValueFromResponse(row?.code,columnIndex,subIndex)"
                (keyup)="keyup($event.target.value, subIndex, columnIndex, rowIndex)" type="text" class="input-field"
                [disabled]="isViewMode" [readonly]="isViewMode" [attr.minLength]="1" [attr.maxLength]="15">
            </div>
            <div *ngIf="subColumn.typ === 'DATE'" class="form-input my-2" [ngClass]="{'opacity-half':isDisabled}">
              <app-datepicker datePickerClass="input-field"
                (setDate)="onDateChange($event,subIndex, columnIndex, rowIndex)"
                [defaultVal]="getValueFromResponse(row?.code,columnIndex,subIndex)" [minDate]="minDate"
               [dateFor]="'subColumn'" [isValid]="" [isDisabled]="isDisabled"
                [plhldr]="'DD/MM/YYYY'" [errMsg]="" [dpPlacement]="'top'" [isLeftIcon]="true">
              </app-datepicker>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>